import React, { useEffect } from "react";

export default function Slider() {

  useEffect(() => {

    const parallaxBox = document.getElementById("parallax");
    if (!parallaxBox) return;

    const layers = [];
    const speeds = [25, 20, 35, 30, 45, 30, 25, 40];

    for (let i = 2; i <= 9; i++) {
      const el = document.getElementById("l" + i);
      if (el) {
        layers.push({
          el,
          speed: speeds[i - 2]
        });
      }
    }

    const handleMove = (event) => {
      const rect = parallaxBox.getBoundingClientRect();

      const x = event.clientX - rect.left;
      const y = event.clientY - rect.top;

      const centerX = rect.width / 2;
      const centerY = rect.height / 2;

      layers.forEach(layer => {
        const moveX = (x - centerX) / layer.speed;
        const moveY = (y - centerY) / layer.speed;

        layer.el.style.transform = `translate(${moveX}px, ${moveY}px)`;
      });
    };

    parallaxBox.addEventListener("mousemove", handleMove);

    return () => {
      parallaxBox.removeEventListener("mousemove", handleMove);
    };

  }, []);


  return (
    <section className="hero-area bg-primary" id="parallax">
      <div className="container">
        <div className="row">
          <div className="col-lg-11 mx-auto">
            <h1 className="text-white font-tertiary">Hi! I’m<br />we are a movie<br />website</h1>
          </div>
        </div>
      </div>
      <div className="layer-bg w-100">
        <img className="img-fluid w-100" src="images/illustrations/leaf-bg.png" alt="bg-shape" />
      </div>
      <div className="layer" id="l2">
        <img src="/images/illustrations/dots-cyan.png" alt="bg-shape" />
      </div>
      <div className="layer" id="l3">
        <img src="/images/illustrations/leaf-orange.png" alt="bg-shape" />
      </div>
      <div className="layer" id="l4">
        <img src="/images/illustrations/dots-orange.png" alt="bg-shape" />
      </div>
      <div className="layer" id="l5">
        <img src="/images/illustrations/leaf-yellow.png" alt="bg-shape" />
      </div>
      <div className="layer" id="l6">
        <img src="/images/illustrations/leaf-cyan.png" alt="bg-shape" />
      </div>
      <div className="layer" id="l7">
        <img src="/images/illustrations/dots-group-orange.png" alt="bg-shape" />
      </div>
      <div className="layer" id="l8">
        <img src="/images/illustrations/leaf-pink-round.png" alt="bg-shape" />
      </div>
      <div className="layer" id="l9">
        <img src="/images/illustrations/leaf-cyan-2.png" alt="bg-shape" />
      </div>
      <ul className="list-unstyled ml-5 mt-3 position-relative zindex-1">
        <li className="mb-3"><a className="text-white" href="https://themefisher.com/"><i className="ti-facebook"></i></a></li>
        <li className="mb-3"><a className="text-white" href="https://themefisher.com/"><i className="ti-instagram"></i></a></li>
        <li className="mb-3"><a className="text-white" href="https://themefisher.com/"><i className="ti-dribbble"></i></a></li>
        <li className="mb-3"><a className="text-white" href="https://themefisher.com/"><i className="ti-twitter"></i></a></li>
      </ul>
    </section>
  );
}